<template>
  <div class="search-content">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'ExameCenterLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '大课间申报'
            },
          ],
          active: () => {
            switch (this.$route.path) {
              case '/dakejian/DakejianList':
                return '1'
              case '/dakejian/KaojiApplyList':
                return '2'
              case '/dakejian/KaoguanList':
                return '3'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/club/ClubList')
                break
              case '2':
                this.$router.push('/club/KaojiApplyList')
                break
              case '3':
                this.$router.push('/club/KaoguanList')
                break
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>